import { Error } from '~/Api/User/ProductGroup/RoMaxPrice/Error';

export class ValidationResult {
	public readonly groupId: string | null;

	public readonly countryErrors: Error[];

	public readonly productErrors: Error[];

	public readonly referencePackageSizeIsMissing: boolean;

	public constructor(
		groupId: string | null,
		referencePackageSizeIsMissing: boolean,
		productErrors: Error[],
		countryErrors: Error[]
	) {
		this.groupId = groupId;
		this.referencePackageSizeIsMissing = referencePackageSizeIsMissing;
		this.productErrors = productErrors;
		this.countryErrors = countryErrors;
	}
}
